import { Component, OnInit } from '@angular/core';
import { UserService } from '../../Services/Users.service';
import { ActivatedRoute,Router } from '@angular/router';
import { AuthService } from '../../Services/AuthGard.service';
import {GlobalService} from '../../Services/global.service';
declare var $;
import * as CryptoJS from 'crypto-js';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css'],
  providers: [UserService]
})
export class changepasswordComponent implements OnInit {
  title: string = "Change password";
  enpyid:string;
  userid:string;
  newPassword:string;
  password:string;
  validationMsg:string;
  resetLinkTrack: { user_name: any; secret_code: any; link: string; };
  passwordType: boolean = false;
  passwordConfirmType: boolean = false;
  securityQuestions : Array<any> = [];
  securityPasswordPopup:boolean = false;
  que_id: string;
  userId: string;
  user_name: string;
  questionUserId: string;
  securityQueFlag: boolean=false;
  seqQue: boolean=false;
  nonAsciiOccurenece: boolean;
  nonAsciiOccurenece1: boolean;
  confpassword: string;
  newpassword: string;


  constructor(private AuthService : AuthService,private userService : UserService,
    private router : Router,private route: ActivatedRoute, private translate: TranslateService,private globalService: GlobalService) {
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translate.use(lang_name);
    this.translate.reloadLang(lang_name);


    // const theUser = JSON.parse(localStorage.getItem('currentUser'));
    // console.log(theUser);
    // this.userId = theUser.user.userid;
  }

  


  changePasswordType(type) {
    
    if (type == 'new') {
      this.passwordType = !this.passwordType;
    } else if (type == 'confirm') {
      this.passwordConfirmType = !this.passwordConfirmType;
    }
  }



  changePassword(chnagePswForm){
    var changePwdObj = {
      userid : this.userid,
      newPassword : this.newPassword,
      password : this.password,
      // needs to be checked 22/10/21
      community_user: false
    };
    console.log("changePwdObj",changePwdObj);
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(changePwdObj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    };
    console.log("authentication",authentication);
    this.userService.changePassword(authentication)
    .subscribe(user => {
        if(user.success){
          $('#successModal').modal('show');
          this.setResetLinkTrack();
        } else {
          this.validationMsg = user.message;
        }
      });

  }

  closeSuccessModal(){
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translate.reloadLang(lang_name);
    this.router.navigate(['/login']);
  }

  IsForChangePassword(id:any){

      this.userService.IschangePassword(id)
      .subscribe(result => {
        console.log('result===>',result);
        
     
        if (result.data == '' || result.data == null) {

          let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
          this.translate.reloadLang(lang_name);
          this.router.navigate(['/login']);
        }else{
          
          this.userid = result.data[0];
          this.user_name = result.data[0];
          this.userService.getUserIdbyUserName(this.user_name)
          .subscribe(res=>{
            console.log('response corresponding to username and question security',res);
            this.questionUserId = res.data.user_id;
            if(res.data.seq_Que){
            this.securityPasswordPopup = res.data.seq_Que;
            }else{
              this.securityPasswordPopup = res.data.seq_Que;
            }
            
          });
        
          this.resetLinkTrack = {
            user_name: result.data[0],
            secret_code: result.data[2],
            link: location.href
          }
        }
      });

  }

  setResetLinkTrack() {
    this.userService.setResetLinkTrack(this.resetLinkTrack).subscribe(
      res => {
        console.log(res);
      },
      error => {
        console.log(error)
      }
    )
  }





  ngOnInit() {

    $("#preloader").css('display','none');
    this.route.params.subscribe(params => {
      let id = params['id'];
      this.IsForChangePassword(id);
      console.log(this.userid,"new user id");
      // In a real app: dispatch action to load the details here.
   
  });
  
   

   let lang_id = this.globalService.getLangId();
   this.userService.getSecurityQuestions(lang_id)
     .subscribe(questions =>{
       if(questions.success){
         this.securityQuestions = questions.data;
         $("#preloader").css('display','none');
       }
      
     });


  }
ngDoCheck(){

  

}

  updateSecurityQue(form){
    let question = form.value.que;
    if(form.valid){
      this.securityQuestions.forEach(que=>{
        if(question == que.que){
          this.que_id = que.que_id;
          const obj={
            question_id:this.que_id,
            answer: form.value.ans,
            question:form.value.que
          } 
          this.userService.changeSecurityQuestionNAnswer(this.questionUserId, obj)
          .subscribe(res =>{
              console.log(res,"resssponse");
              this.securityPasswordPopup = true;
          });   
        }
      })
     
     
    } else{
        console.log("enter valid values");
    }

  
  }

  // changeSecurityQue(ev:any){
  //   console.log(ev.target.value);
  // }

  checkForNonAscii()
  {   
    var ascii = /[^\u0000-\u007f]/;
    console.log("event is here",this.newPassword);
    if ( !ascii.test( this.newPassword ) ) {  
      this.nonAsciiOccurenece = false;
      console.log(this.nonAsciiOccurenece);
    }else{
      this.nonAsciiOccurenece = true;
      console.log(this.nonAsciiOccurenece);
      // alert("non ascii is here");
    } 
  }
  checkForNonAsciicpass(){
    var ascii = /[^\u0000-\u007f]/;
    console.log("event is here",this.confpassword);
    if ( !ascii.test( this.password ) ) {  
      this.nonAsciiOccurenece1 = false;
      console.log(this.nonAsciiOccurenece1);
    }else{
      this.nonAsciiOccurenece1 = true;
      console.log(this.nonAsciiOccurenece1);
      // alert("non ascii is here");
    } 
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/ChangePassword/changepassword.component.ts